// ## ESTADOS PERMITIDOS PARA LAS SOLICITUDES
const RETRACTION = 'retraction'
const APPROVED = 'approved'
const CANCELLED = 'cancelled'
const CLOSED = 'closed'
const PENDING = 'pending'
const REJECTED = 'rejected'
const NOTAVAILABLE = 'not_available'

const spanish = {
    [PENDING]: 'Pendiente'
    , [CLOSED]: 'Cerrado'
    , [CANCELLED]: 'Cancelado'
    , [APPROVED]: 'Aprobado'
    , [RETRACTION]: 'Retracción'
    , [REJECTED]: 'Rechazado'
}

const spanishToGestorImpuestos = {
    [PENDING]: 'Sin gestionar'
    , [CLOSED]: 'Cerrado'
    , [CANCELLED]: 'Cancelado'
    , [APPROVED]: 'Gestionado'
    , [RETRACTION]: 'Retracción'
    , [REJECTED]: 'Rechazado',
    [NOTAVAILABLE]: "No disponible"
}

// ## TRADUCIR AL ESPAÑOL TODOS LOS ESTADOS EN CASO DE NO EXITIR SE MANDA EN NULL
const translateToSpanish = ({ state = '' }) =>  spanish[state] || null

// ## CONSTANTES PARA EL PERFIL GESTOR DE TIQUETES
const translateToSpanishToGestorImpuestos = ({ state = '' }) => spanishToGestorImpuestos[state] || null

export {
    RETRACTION
    , REJECTED
    , APPROVED
    , CANCELLED
    , CLOSED
    , PENDING
    , translateToSpanish
    , translateToSpanishToGestorImpuestos
}
